import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var embedTypes = ['application/pdf'];
var FilePreview = function (_a) {
    var file = _a.file, url = _a.url, mimeType = _a.mimeType;
    if (!file && !url)
        return null;
    var fileUrl = file ? URL.createObjectURL(file) : url;
    var type = file ? file.type : mimeType;
    if (!type || type.includes('image')) {
        return (_jsx("div", { className: "text-center mt-2", children: _jsx("img", { className: "full-width mb-3", src: fileUrl, alt: file ? "preview of ".concat(file.name) : '' }) }));
    }
    else if (embedTypes.includes(type)) {
        return (_jsx("embed", { className: "full-width min-height-sm mb-3 mt-2", src: fileUrl }));
    }
    return null;
};
export default memo(FilePreview);
